import { MdlDialogReference, MdlDialogService } from '@angular-mdl/core';
import { UploadDialogBase } from './upload-dialog-base';
import { UploadStorage } from '../../storages/upload-storage';
import { CategoryNaturalKey } from '../../../../documents';

export abstract class UpdateDocumentDialogBase extends UploadDialogBase {

    public readonly generalDocumentType = 'general-document';
    public readonly applicationTrainingType = 'application-training';
    public readonly siteCommunicationType = 'site-communications';
    public readonly sponsorCommunicationType = 'sponsor-communications';
    public readonly studyManualType = 'study-manuals';
    public readonly trainingMaterialsType = 'training-materials';
    public readonly siteActionsType = 'site-actions';
    public readonly documentInfoComponentSelector: string;

    protected constructor(
        uploadStorage: UploadStorage,
        protected readonly dialog: MdlDialogReference,
        protected readonly dialogService: MdlDialogService,
        categoryNaturalKey: CategoryNaturalKey
    ) { 
        super(uploadStorage, dialog);
        this.documentInfoComponentSelector = this.getDocumentInfoComponentSelector(categoryNaturalKey);
    }

    protected getDocumentInfoComponentSelector(categoryNaturalKey: CategoryNaturalKey): string {
        switch (categoryNaturalKey) {
        case 'general-manuals':
        case 'general-communications':
        case 'general-training-materials':
            return this.generalDocumentType;
        case 'application-training':
            return this.applicationTrainingType;
        case 'lab-manuals':
            return this.studyManualType;
        case 'site-communications':
            return this.siteCommunicationType;
        case 'sponsor-communications':
            return this.sponsorCommunicationType;
        case 'training-materials':
            return this.trainingMaterialsType;
        case 'site-actions':
            return this.siteActionsType;
        default:
            throw new Error('invalid category');
        }
    }

    protected async showConfirm(confirmationText: string): Promise<boolean> {
        this.confirmationDialogOpened = true;

        try {
            await this.dialogService.confirm(confirmationText, 'No', 'Yes').toPromise();
            return true;
        } catch {
            return false;
        } finally {
            this.confirmationDialogOpened = false;
        }
    }
}